export default "__VITE_ASSET__Cl0wYhwz__"